import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/product'], resolve),
          meta: {
            title: '产品'
          }
        },
        {
          path: '/aboutCore',
          name: 'aboutCore',
          component: resolve => require(['@/view/aboutCore'], resolve),
          meta: {
            title: '关于扬迈云'
          }
        }, {
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/solution'], resolve),
          meta: {
            title: '解决方案'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '解决方案'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js